import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { ActionPresentation } from '../Action/ActionPresentation.js';
import { IconPresentation } from '../Icon/IconPresentation.js';
import { hostClass } from './Badge.styles.js';

var defaultProps = {
  look: "primary",
  type: "text",
  size: "default",
  iconVariant: "solid"
};
var BadgePresentation = fComp(function (props) {
  var _cleanupClassObject;
  var id = props.id,
    className = props.className,
    name = props.name,
    isStencilHost = props.isStencilHost,
    text = props.text,
    look = props.look,
    type = props.type,
    size = props.size,
    htmlAttrs = props.htmlAttrs,
    disabled = props.disabled,
    href = props.href,
    onKeyboardFocusChange = props.onKeyboardFocusChange,
    onMouseHoverChange = props.onMouseHoverChange,
    footnoteIdentifier = props.footnoteIdentifier,
    footnoteIdItem = props.footnoteIdItem,
    icon = props.icon,
    iconVariant = props.iconVariant,
    otherProps = __rest(props, ["id", "className", "name", "isStencilHost", "text", "look", "type", "size", "htmlAttrs", "disabled", "href", "onKeyboardFocusChange", "onMouseHoverChange", "footnoteIdentifier", "footnoteIdItem", "icon", "iconVariant"]);
  var internalHref = footnoteIdItem !== null && footnoteIdItem !== void 0 ? footnoteIdItem : href;
  var typeInternal = type;
  if (type === "text") {
    if (text === undefined || text === "" || text && text.trim() === "") {
      typeInternal = "dot";
    }
  }
  return /*#__PURE__*/React.createElement(Host, Object.assign({
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__").concat(look), look), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__").concat(typeInternal), typeInternal), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__").concat(size), size), _cleanupClassObject)),
    isStencilHost: isStencilHost
  }, htmlAttrs), typeInternal === "icon" ? /*#__PURE__*/React.createElement(IconPresentation, {
    icon: icon,
    size: "small",
    noMargin: true,
    variant: iconVariant
  }) : typeInternal === "text" ? /*#__PURE__*/React.createElement(React.Fragment, null, footnoteIdentifier && size === "large" ? /*#__PURE__*/React.createElement(ActionPresentation, Object.assign({
    id: id,
    htmlAttrs: htmlAttrs,
    disabled: disabled,
    href: disabled ? undefined : internalHref,
    hasTabIndex: true,
    name: name,
    onMouseHoverChange: onMouseHoverChange,
    onKeyboardFocusChange: onKeyboardFocusChange,
    expandToOverlay: true
  }, otherProps), text, /*#__PURE__*/React.createElement("sup", null, footnoteIdentifier)) : text) :
  /*#__PURE__*/
  // typeInternal === "dot"
  React.createElement(React.Fragment, null));
}, defaultProps);
BadgePresentation.displayName = "BadgePresentation";

export { BadgePresentation, defaultProps };
